import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";

export const getColors = () => ({ type: "GET_COLORS" })
export const getColorsRequest = () => ({ type: "GET_COLORS_REQUEST" })
export const getColorsSuccess = payload => ({ type: "GET_COLORS_SUCCESS", payload })
export const getColorsFailed = error => ({ type: "GET_COLORS_FAILED", error })

export function* getColorsSaga() {
    yield put(getColorsRequest())
    try {
        let { data: payload } = yield call(axios,"/colors")
        yield put(getColorsSuccess(payload))
    } catch(err){
        yield put(getColorsFailed(err))
    }
}

export default function* colorsSagaWatcher() {
    yield takeEvery("GET_COLORS", getColorsSaga)
}